
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {Button, Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";
import AdminService from "../../../services/adminService";
import PermissionListTable from "../permission/ListTable";
import AdminDetailsDummy from "./DetailsDummy";
import UserPermissionService from "../../../services/userPermissionService";

class AdminDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adminUID: "",
      adminData: {},
      userPermissionDTOList: {},
    };
    this.loadUserPermissionList = this.loadUserPermissionList.bind(this);
  }

  componentDidMount() {
    const { uniqueId } = this.props.match.params;
    this.setState({ adminUID: uniqueId });
    AdminService.fetch(uniqueId).then((response) => {
      this.setState({ adminData: response.data });
      this.loadUserPermissionList();
    });
  }

  loadUserPermissionList() {
    UserPermissionService.listByUser(this.state.adminUID).then((response) => {
      this.setState({ userPermissionDTOList: response.data });
    });
  }

  render() {
    const { adminData, userPermissionDTOList } = this.state;
    let obj = this;
    return (
      <>
        <SimpleHeader
          name="Details"
          parentName="User"
          heading="ClashMate"
          newBtnUrl="/crm/create"
          newBtnText="Create User"
          secBtnUrl="/crm/list"
          secBtnText="List All Users"
        />
        <Container className="mt--6" fluid>
          <Row>
            <Col xl="12">
              <Card className="mb-4">
                <CardHeader>
                  <h3 className="mb-0">{adminData.fullName}
                  </h3>
                </CardHeader>
                <CardBody>
                  <AdminDetailsDummy adminData={adminData}/>
                </CardBody>
              </Card>
            </Col>
            {/*<Col xl="12">
              <PermissionListTable
                userPermissionList={userPermissionDTOList}
                adminComponentObj={obj}
                cardTitle="Permission List"
                adminUID={obj.state.adminUID}
                onFormSubmitSuccess={this.loadUserPermissionList}
              />
            </Col>*/}
          </Row>
        </Container>
      </>
    );
  }
}

export default AdminDetails;
